<mmscan-button [text]="true" [icon]="primeIcons.SIGN_OUT" (buttonClick)="onLogout()" />
